import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { MosarStatsModule } from "@MOSAR/mosar-statistics-dashboard";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { MentionModule } from "angular-mentions";
import { SharedModule } from "app/shared/shared.module";
import { MaterialModule } from "layout/material.module";
import { SystemProofRoutingModule } from "./system-proof-routing.module";
import { SystemproofComponent } from "./system-proof.component";
import { filterCampaignBySystemPipe, filterTestProtocolByCampaignPipe, filterUsecaseByTestProtocolPipe } from "./system-proof.pipe";
import { CollectionModule } from "app/collection/collection.module";
import { CampaignItemCollectionComponent } from "./campaign/campaign-item-collection/campaign-item-collection.component";

@NgModule({
  declarations: [
    SystemproofComponent,
    filterCampaignBySystemPipe,
    filterTestProtocolByCampaignPipe,
    filterUsecaseByTestProtocolPipe,
    CampaignItemCollectionComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    NgSelectModule,
    SharedModule,
    MentionModule,
    NgbModule,
    MosarStatsModule,
    ReactiveFormsModule,
    SystemProofRoutingModule
  ],
})
export class SystemProofModule {}
